<template>
  <div class="fixed-top">
    Debug:
    <button class="button button-primary" @click="printCameraDetails()">Print Cam</button>
    <button class="button button-primary" @click="enableZoom()">Enable Zoom</button>
    <button class="button button-primary" @click="freeCam()">Free Cam</button>
    <button class="button button-primary" @click="goto()">GOTO test</button>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    printCameraDetails() {
      this.$root.comms.send("singtel-printcam");
    },
    enableZoom() {
      this.$root.comms.send("singtel-enablezoom");
    },
    freeCam() {
      this.$root.comms.send("singtel-freecam");
    },
    goto() {
      var powerButtonPos = {
        fov: 60,
        position: {
          x: -449.55525517247315,
          y: 135.7917961603354,
          z: 160.6967590069185,
        },
        rotation: {
          w: 0.20560437864517092,
          x: -0.12607720277907447,
          y: 0.8273219575296593,
          z: 0.5073162297922569,
        },
      };

      var selfieCamPos = {
        fov: 80,
        position: {
          x: -451,
          y: 136.5,
          z: 166.7,
        },
        rotation: {
          x: -0.25165898698387046,
          y: 0.5568937989241478,
          z: 0.18192673380839053,
          w: 0.7703503842511497,
        },
      };

      this.$root.comms.send("singtel-goto", selfieCamPos);
    },
  },
};
</script>

<style scoped></style>
